import { RADIUS, SPACE, T } from '@/design/tokens';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Button } from './Button';

export function RouteError() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unknown error';

  return (
    <div
      role="alert"
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        background: T.bg,
        color: T.text,
        padding: SPACE.lg,
      }}
    >
      <div
        style={{
          maxWidth: 480,
          textAlign: 'center',
          background: T.card,
          border: `1px solid ${T.border}`,
          borderLeft: `3px solid ${T.red}`,
          borderRadius: RADIUS.md,
          padding: SPACE.lg,
        }}
      >
        <h1 style={{ margin: 0, fontWeight: 400, fontSize: 22 }}>Page broke</h1>
        <p style={{ color: T.textMuted, marginTop: SPACE.md, fontSize: 13 }}>{message}</p>
        <Button as="a" href="/" style={{ marginTop: SPACE.lg }}>
          Back to garage
        </Button>
      </div>
    </div>
  );
}
